var React = require('react');

function VideoPlay (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-962 -620)","fill":"currentColor","fillRule":"nonzero"},React.createElement("g",{"transform":"translate(962 612)"},React.createElement("path",{"d":"m12.8 31.2l9.6-7.2-9.6-7.2v14.4zm3.2-23.2c-8.832 0-16 7.168-16 16s7.168 16 16 16 16-7.168 16-16-7.168-16-16-16zm0 28.8c-7.056 0-12.8-5.744-12.8-12.8s5.744-12.8 12.8-12.8 12.8 5.744 12.8 12.8-5.744 12.8-12.8 12.8z"})))));
}

VideoPlay.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 32 32"};

module.exports = VideoPlay;

VideoPlay.default = VideoPlay;
